import { ChallengeCard } from "../challenge/ChallengeView.interface";

interface AccomplishmentBadge {
  status: "locked" | "unlocked";
  coverImgUrl?: string;
  title?: string;
  description?: string;
  level?: string;
  subTitle?: string;
}

interface UnlockedReward {
  coverImgUrl: string;
  title: string;
  shortDescription: string;
  promotion: string;
  subTitle: string;
  targetUrl: string;
  expires: string;
  tags: Array<string>;
}

interface Timeline {
  challenges?: Array<ChallengeCard>;
}

interface Stats {
  streak: number;
  zenPoints: number;
  maxZenPoints: number;
  badges: Array<AccomplishmentBadge>;
}
interface ProfileView {
  profilePhotoUrl: string;
  displayName: string;
  level: string;
  stats: Stats;
  timeline: Timeline;
  rewards: Array<UnlockedReward>;
}

const defaultProfileView: ProfileView = {
  displayName: "",
  level: "",
  profilePhotoUrl: "",
  stats: {
    streak: 0,
    maxZenPoints: 0,
    zenPoints: 0,
    badges: [],
  },
  timeline: {},
  rewards: [],
};

export {
  ProfileView,
  Stats,
  Timeline,
  UnlockedReward,
  AccomplishmentBadge,
  defaultProfileView,
};
